import { Context } from 'common/contexts'
import { GlobalStyles } from 'common/styles'
import { useEffect } from 'react'
import { useTranslation, withTranslation } from 'react-i18next'
import { Toaster } from 'sonner'
import { Landing } from 'views'

export const App = () => {
  const { t } = useTranslation()
  const lang = localStorage.getItem('Localization') ?? 'uk'
  useEffect(() => {
    document.title = t('title-head')
  }, [lang])

  return (
    <>
      <Context>
        <GlobalStyles />
        <Toaster duration={4000} position="top-center" />
        <Landing />
      </Context>
    </>
  )
}

export default withTranslation()(App)
